<template>
  <div class="accruals-sync-bar" data-testid="accruals-data-page__sync-bar">
    <div class="accruals-sync-bar__main">
    <div class="accruals-sync-bar__metrics">
      <div class="accruals-sync-bar__metric">
        <span class="accruals-sync-bar__metric-label">{{ totalLabel }}</span>
        <span class="accruals-sync-bar__metric-value" data-testid="accruals-data-page__total-synced">
          {{ totalValue }}
        </span>
      </div>
      <div class="accruals-sync-bar__metric">
        <span class="accruals-sync-bar__metric-label">Last Synced</span>
        <span class="accruals-sync-bar__metric-value" data-testid="accruals-data-page__last-synced-value">
          {{ lastSyncedLabel || '—' }}
        </span>
      </div>
      <div class="accruals-sync-bar__metric">
        <span class="accruals-sync-bar__metric-label">Version</span>
        <span class="accruals-sync-bar__metric-value" data-testid="accruals-data-page__version-value">
          {{ versionLabel || '—' }}
        </span>
      </div>
    </div>

    <div class="accruals-sync-bar__actions">
      <span class="accruals-sync-bar__cutoff" data-testid="accruals-data-page__cutoff">
        {{ cutoffLabel }}
      </span>
      <button
        v-if="canSync"
        type="button"
        class="accruals-sync-bar__sync-btn"
        data-testid="accruals-data-page__sync-btn"
        :disabled="loading"
        @click="$emit('sync')"
      >
        <span class="accruals-sync-bar__sync-icon-wrap">
          <img :src="syncIcon" alt="" class="accruals-sync-bar__sync-icon" />
        </span>
        <span>Sync now</span>
      </button>
    </div>
    </div>
    <p
      v-if="issueLabel"
      class="accruals-sync-bar__issue"
      :class="{ 'accruals-sync-bar__issue--warning': issueTone === 'warning' }"
      data-testid="accruals-data-page__ingest-issue"
    >
      {{ issueLabel }}
    </p>
  </div>
</template>

<script>
import { ACCRUALS_ASSETS } from '../accrualsPageConstants';

export default {
  name: 'AccrualsSyncStatusBar',
  props: {
    totalLabel: { type: String, default: 'Total POs Synced' },
    totalValue: { type: String, default: '0' },
    lastSyncedLabel: { type: String, default: '' },
    versionLabel: { type: String, default: '' },
    cutoffLabel: { type: String, default: 'Cut-off: —' },
    loading: { type: Boolean, default: false },
    canSync: { type: Boolean, default: true },
    issueLabel: { type: String, default: '' },
    issueTone: { type: String, default: 'error' },
    syncIcon: { type: String, default: ACCRUALS_ASSETS.ICON_SYNC_STATUS },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsSyncStatusBar.scss';
</style>
